import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";

export function fromHtmlToEditorState(input: string | null | undefined) {
  const blocksFromHtml = htmlToDraft(input ?? "");
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(
    contentBlocks,
    entityMap,
  );
  return EditorState.createWithContent(contentState);
}
